// extracted by mini-css-extract-plugin
export default {"layout":"TiaPage_layout__kms-p","img":"TiaPage_img__h1IQT"};